import { addDoc, collection, getDocs, orderBy, query, serverTimestamp, updateDoc, doc, where, deleteDoc } from 'firebase/firestore'
import { db } from '@/firebase'

export const subscriptionPlanService = {
  async listPlans(branchId) {
    const constraints = []
    if (branchId && branchId !== 'all-branches') {
      constraints.push(where('branchId', '==', branchId))
    }
    const q = query(collection(db, 'subscriptionPlans'), ...constraints, orderBy('name', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
  },

  async createPlan(plan) {
    const payload = {
      name: plan.name,
      code: plan.code,
      branchId: plan.branchId || null,
      amount: Number(plan.amount || 0),
      washesIncluded: plan.washesIncluded === 'unlimited' ? 'unlimited' : Number(plan.washesIncluded || 0),
      durationDays: Number(plan.durationDays || 0), // 0 for prepaid/unlimited duration policies
      eligibleServiceIds: Array.isArray(plan.eligibleServiceIds) ? plan.eligibleServiceIds : [],
      eligibleTierIds: Array.isArray(plan.eligibleTierIds) ? plan.eligibleTierIds : [],
      isActive: plan.isActive !== false,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }
    const ref = await addDoc(collection(db, 'subscriptionPlans'), payload)
    return ref.id
  },

  async updatePlan(planId, patch) {
    const payload = {
      ...patch,
      amount: patch.amount !== undefined ? Number(patch.amount || 0) : undefined,
      washesIncluded:
        patch.washesIncluded !== undefined
          ? patch.washesIncluded === 'unlimited'
            ? 'unlimited'
            : Number(patch.washesIncluded || 0)
          : undefined,
      durationDays: patch.durationDays !== undefined ? Number(patch.durationDays || 0) : undefined,
      eligibleServiceIds:
        patch.eligibleServiceIds !== undefined
          ? Array.isArray(patch.eligibleServiceIds)
            ? patch.eligibleServiceIds
            : []
          : undefined,
      eligibleTierIds:
        patch.eligibleTierIds !== undefined
          ? Array.isArray(patch.eligibleTierIds)
            ? patch.eligibleTierIds
            : []
          : undefined,
      updatedAt: serverTimestamp(),
    }

    Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k])
    await updateDoc(doc(db, 'subscriptionPlans', planId), payload)
  },

  async removePlan(planId) {
    await deleteDoc(doc(db, 'subscriptionPlans', planId))
  },
}

